<script setup lang="ts">
type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'tertiary';
type ButtonSize = 'small' | 'default';

const {
  loading = false,
  disabled = false,
  block = false,
  size = 'default',
  type = 'button',
  variant = 'primary',
  icon = undefined,
  to = undefined,
} = defineProps<{
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
  size?: ButtonSize;
  type?: 'submit' | 'button';
  variant?: ButtonVariant;
  icon?: string;
  to?: string | Record<string, any>;
}>();

const buttonClasses = computed(() => ['app-btn', `app-btn--${variant}`]);
</script>

<template>
  <v-btn
    flat
    :class="buttonClasses"
    data-cy="submit"
    data-testid="button"
    :type="type"
    :loading="loading"
    :disabled="disabled"
    :size="size"
    :block="block"
    :to="to"
  >
    <template #default>
      <slot>
        <v-icon v-if="icon">{{ icon }}</v-icon>
      </slot>
    </template>

    <template #append>
      <slot name="append" />
    </template>

    <template #prepend>
      <slot name="prepend" />
    </template>
  </v-btn>
</template>
